import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddVenture(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [buffer, setBuffer] = useState('');
    const [series, setSeries] = useState('');
    const [company, setCompany] = useState(null);
    const [companies, setCompanies] = useState([]);
    const [city, setCity] = useState('');
    const [postal, setPostal] = useState('');
    const [address, setAddress] = useState('');
    const [identification, setIdentification] = useState('');
    const [description, setDescription] = useState('')

    const _submit = (e) => {
        e.preventDefault();
        // TODO: Zrobić walidację formularza (firma)
        const data = {name: name, buffer_account: buffer, series: series, city: city, postal_code: postal,
            address: address, company_id: company?.key, identification: identification, description: description};
        fetch(`/api/venture`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddVenture'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        setName('');
        setBuffer('');
        setSeries('');
        async function fetchCompanies() {
            await fetch(`/api/company`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setCompanies(data.map((item) => {
                        return {key: item.id, text: item.name};
                    }))
                })
                .catch(err => {
                    console.log(err)
                })
        }
        fetchCompanies();
        return () => abortController.abort();
    }, [props.edit, user.token])

    return (
        <Panel
            isOpen={props.edit}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Kontrakt"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <p>{props.edit.keystring}</p>
            <form onSubmit={_submit} id='AddVenture'>
                <Dropdown
                    label="Firma"
                    selectedKey={company ? company.key : undefined}
                    onChange={(e, selected) => setCompany(selected)}
                    placeholder="Wybierz z listy"
                    options={companies}
                />
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField label='Konto' value={buffer} onChange={(e) => setBuffer(e.target.value || '')}/>
                <TextField required label='Seria Dokumentów' value={series} onChange={(e) => setSeries(e.target.value || '')}/>
                <TextField label='Miasto' value={city} onChange={(e) => setCity(e.target.value || '')}/>
                <TextField label='Kod pocztowy' value={postal} onChange={(e) => setPostal(e.target.value || '')}/>
                <TextField label='Adres' value={address} onChange={(e) => setAddress(e.target.value || '')}/>
                <TextField label='Numer identyfikacyjny' value={identification} onChange={(e) => setIdentification(e.target.value || '')} maxLength={90} />
                <TextField label='Opis' value={description} onChange={(e) => setDescription(e.target.value || '')} maxLength={255} multiline/>
            </form>
        </Panel>
    )
}

export default AddVenture;